import * as React from "react";
import { hot } from "react-hot-loader";
import { Link } from "react-router-dom";
declare var configcustoms: any;
declare var libelle: any;

class Presentation extends React.Component<{}, {}> {

  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <div id="presentation">
        <div className="row pt-1">
          <div className="col-12 col-sm-3 align-self-center">
            <img src="./assets/logo_enm.png" className="img-fluid" alt="Logo ENM" />
          </div>

          <div className="col-12 col-sm-9 pt-3 pt-sm-0">
            <div className="custom-card p-4">
              <div className="last-p-no-mb" dangerouslySetInnerHTML={{ __html: libelle.presentation.presentationApp }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default hot(module)(Presentation);
